// root '../../../';

// dependencies
import { Child } from 'pym.js';
// import { select } from 'd3-selection';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
// import config from './config';
// import graphic from './graphic';

// styles
import './styles/index.scss';
import './styles/gallery.scss';
import desktopVideo from './media/ai-ad-massie.mp4';
import mobileVideo from './media/ai-ad-massieMOBILE.mp4';
import desktopThumbnail from './media/ai-ad-massie-thumbnailDT.jpg';
import mobileThumbnail from './media/ai-ad-massie-thumbnailMOBILE.jpg';

/* develblock:start */
import meta from './data/meta.json';
import data from './data/data.json';

const pkg = require('../package.json');

function syncGalleryVideoSources(gal, mobile) {
  if (!gal) return;
  const posterSrc = mobile ? mobileThumbnail : desktopThumbnail;
  const videoSrc = mobile ? mobileVideo : desktopVideo;
  gal.querySelectorAll('.video-item').forEach((item) => {
    const video = item.querySelector('video');
    const posterImage = item.querySelector('.video-poster');
    const playButton = item.querySelector('.video-play-button');
    const videoControls = item.querySelector('.video-controls');
    if (video) {
      if (!video.paused) {
        video.pause();
      }
      video.currentTime = 0;
      video.src = videoSrc;
      video.poster = posterSrc;
      video.addEventListener('loadedmetadata', function onVideoMetadata() {
        video.removeEventListener('loadedmetadata', onVideoMetadata);
        requestAnimationFrame(() => {
          if (window.pymChild) window.pymChild.sendHeight();
        });
      });
    }
    if (posterImage) {
      posterImage.src = posterSrc;
      posterImage.classList.remove('hidden');
    }
    if (playButton) playButton.classList.remove('hidden');
    if (videoControls) videoControls.classList.remove('visible');
  });
  requestAnimationFrame(() => {
    if (window.pymChild) window.pymChild.sendHeight();
  });
}

function galRez() {
  Array.from(document.getElementsByClassName('scGallery')).forEach((gal) => {
    const el = gal; // avoid mutating function parameter directly (no-param-reassign)
    if (el.offsetWidth < 660) {
      el.style.maxWidth = '100%';
      el.classList.add('mobile');
    } else {
      el.style.maxWidth = `${el.dataset.width}px`;
      el.classList.remove('mobile');
    }
    const footer = el.querySelector('div.scroll-footer');
    if (footer) {
      const heights = Array.from(footer.querySelectorAll('.image-description'))
        .filter(d => d.textContent.trim())
        .map((d) => {
          const top = parseFloat(getComputedStyle(d).top) || 0; // absolute offset
          return d.scrollHeight + top;
        });
      const maxHeight = heights.length ? Math.max(...heights) : 0;
      footer.style.height = maxHeight ? `${Math.ceil(maxHeight) + 8}px` : '0';
    }
  });
}

function scgallery(ob) {
  const sendHeight = () => {
    requestAnimationFrame(() => {
      if (window.pymChild) window.pymChild.sendHeight();
    });
  };


  const mediaFiles = [];
  const gal = document.getElementById(ob.container);
  gal.dataset.height = ob.height || 700;
  gal.dataset.width = ob.width || 736;
  gal.dataset.currentIndex = 1;

  const scTitle = document.createElement('h3');
  scTitle.textContent = ob.title;
  gal.appendChild(scTitle);
  const scr1 = document.createElement('div');
  scr1.classList.add('scroll-container');

  const ftr = document.createElement('div');
  ftr.classList.add('scroll-footer');
  const spn = document.createElement('span');
  spn.textContent = '1';
  const spn2 = document.createElement('span');
  spn2.textContent = ` of ${ob.images.length}`;
  if (ob.images.length > 1) {
    ftr.appendChild(spn);
    ftr.appendChild(spn2);
  }
  gal.appendChild(scr1);
  gal.appendChild(ftr);


  const galNav = document.createElement('div');
  galNav.classList.add('gallery-nav');
  const navPrev = document.createElement('button');
  navPrev.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1.52925 7.1951L1.53703 7.18744L6.19595 2.52851C6.4563 2.26816 6.87841 2.26816 7.13876 2.52851C7.39911 2.78886 7.39911 3.21097 7.13876 3.47132L3.61021 6.99988L14.0007 6.99987C14.3688 6.99987 14.6673 7.29835 14.6673 7.66654C14.6673 8.03473 14.3688 8.33321 14.0007 8.33321H3.61017L7.13876 11.8618C7.39911 12.1222 7.39911 12.5443 7.13876 12.8046C6.87841 13.065 6.4563 13.065 6.19595 12.8046L1.53704 8.1457L1.52925 8.13803C1.45614 8.06492 1.40356 7.97906 1.37151 7.88761C1.34842 7.82189 1.33533 7.75145 1.33408 7.67814C1.33402 7.67428 1.33398 7.67041 1.33398 7.66654C1.33398 7.66449 1.33399 7.66244 1.33401 7.6604C1.33475 7.57869 1.35018 7.5005 1.3778 7.42833C1.41026 7.34332 1.46074 7.26361 1.52925 7.1951Z" fill="#0C0C0C"/></svg>';

  galNav.appendChild(navPrev);
  const navNext = document.createElement('button');
  navNext.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M14.4721 7.1951L14.4643 7.18744L9.80535 2.52851C9.545 2.26816 9.12289 2.26816 8.86254 2.52851C8.60219 2.78886 8.60219 3.21097 8.86254 3.47132L12.3911 6.99988L2.00065 6.99987C1.63246 6.99987 1.33398 7.29835 1.33398 7.66654C1.33398 8.03473 1.63246 8.33321 2.00065 8.33321H12.3911L8.86254 11.8618C8.60219 12.1222 8.60219 12.5443 8.86254 12.8046C9.12289 13.065 9.545 13.065 9.80535 12.8046L14.4643 8.1457L14.4721 8.13803C14.5452 8.06492 14.5977 7.97906 14.6298 7.88761C14.6529 7.82189 14.666 7.75145 14.6672 7.67814C14.6673 7.67428 14.6673 7.67041 14.6673 7.66654C14.6673 7.66449 14.6673 7.66244 14.6673 7.6604C14.6666 7.57869 14.6511 7.5005 14.6235 7.42833C14.591 7.34332 14.5406 7.26361 14.4721 7.1951Z" fill="#0C0C0C"/></svg>';
  galNav.appendChild(navNext);
  if (ob.images.length > 1) {
    ftr.appendChild(galNav);
  }

  const centerTo = (idx) => {
    const el = scr1.children[idx - 1];
    if (!el) return;
    const target = el.offsetLeft - (scr1.clientWidth - el.clientWidth) / 2;
    const max = scr1.scrollWidth - scr1.clientWidth;
    const clamped = Math.max(0, Math.min(target, max));
    scr1.scrollTo({ left: clamped, behavior: 'smooth' });
  };

  navPrev.addEventListener('click', (e) => {
    e.preventDefault();
    let currentIndex = parseInt(gal.dataset.currentIndex, 10) - 1;
    if (currentIndex < 1) currentIndex = 1;
    centerTo(currentIndex);
    gal.dataset.currentIndex = currentIndex;
    spn.textContent = currentIndex;
  });

  navNext.addEventListener('click', (e) => {
    e.preventDefault();
    let currentIndex = parseInt(gal.dataset.currentIndex, 10) + 1;
    const maxIdx = scr1.children.length;
    if (currentIndex > maxIdx) currentIndex = maxIdx;
    centerTo(currentIndex);
    gal.dataset.currentIndex = currentIndex;
    spn.textContent = currentIndex;
  });
  ob.images.forEach((im, i) => {
    const imCont = document.createElement('div');
    if (im[3] === 'video') {
      imCont.classList.add('video-item');
      const video = document.createElement('video');
      const isMobile = window.matchMedia('(max-width: 500px)').matches;
      const posterSrc = isMobile ? mobileThumbnail : desktopThumbnail;
      const posterImage = document.createElement('img');
      posterImage.classList.add('video-poster');
      posterImage.src = posterSrc;
      posterImage.alt = '';
      video.poster = posterSrc;
      video.src = isMobile ? mobileVideo : desktopVideo;
      video.muted = false;
      video.autoplay = false;
      video.loop = false;
      video.controls = false;
      video.playsInline = true;
      video.preload = 'none';
      video.addEventListener('loadedmetadata', sendHeight);
      imCont.appendChild(video);
      imCont.appendChild(posterImage);

      const playButton = document.createElement('button');
      playButton.classList.add('video-play-button');
      playButton.setAttribute('aria-label', 'Play video');
      playButton.innerHTML = '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M18 13.5v21l17-10.5z"/></svg>';
      imCont.appendChild(playButton);

      const videoControls = document.createElement('div');
      videoControls.classList.add('video-controls');
      const playPauseButton = document.createElement('button');
      playPauseButton.setAttribute('aria-label', 'Pause video');
      playPauseButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zm6 0h4v14h-4z"/></svg>';
      const seekBar = document.createElement('input');
      seekBar.type = 'range';
      seekBar.min = '0';
      seekBar.max = '100';
      seekBar.value = '0';
      seekBar.step = '0.1';
      seekBar.setAttribute('aria-label', 'Video progress');
      const muteButton = document.createElement('button');
      muteButton.setAttribute('aria-label', 'Mute video');
      muteButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4zm11.5 3a3.5 3.5 0 0 0-1.5-2.87v5.74A3.5 3.5 0 0 0 15.5 12zm0-6.18v2.06a6 6 0 0 1 0 8.24v2.06a8 8 0 0 0 0-12.36z"/></svg>';
      videoControls.appendChild(playPauseButton);
      videoControls.appendChild(seekBar);
      videoControls.appendChild(muteButton);
      imCont.appendChild(videoControls);

      const togglePlayback = () => {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      };
      playButton.addEventListener('click', togglePlayback);
      playPauseButton.addEventListener('click', togglePlayback);
      video.addEventListener('click', togglePlayback);
      muteButton.addEventListener('click', () => {
        video.muted = !video.muted;
      });
      seekBar.addEventListener('input', () => {
        if (video.duration) video.currentTime = (parseFloat(seekBar.value) / 100) * video.duration;
      });
      video.addEventListener('timeupdate', () => {
        if (video.duration) seekBar.value = (video.currentTime / video.duration) * 100;
      });
      video.addEventListener('play', () => {
        posterImage.classList.add('hidden');
        playButton.classList.add('hidden');
        videoControls.classList.remove('visible');
        playPauseButton.setAttribute('aria-label', 'Pause video');
        playPauseButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zm6 0h4v14h-4z"/></svg>';
      });
      video.addEventListener('pause', () => {
        videoControls.classList.add('visible');
        playPauseButton.setAttribute('aria-label', 'Play video');
        playPauseButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
      });
      video.addEventListener('volumechange', () => {
        muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        muteButton.classList.toggle('muted', video.muted);
        muteButton.innerHTML = video.muted
          ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4zm11.3.3-1.4 1.4 2.3 2.3-2.3 2.3 1.4 1.4 2.3-2.3 2.3 2.3 1.4-1.4-2.3-2.3 2.3-2.3-1.4-1.4-2.3 2.3z"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4zm11.5 3a3.5 3.5 0 0 0-1.5-2.87v5.74A3.5 3.5 0 0 0 15.5 12zm0-6.18v2.06a6 6 0 0 1 0 8.24v2.06a8 8 0 0 0 0-12.36z"/></svg>';
      });

      imCont.classList.toggle('active', i === 0);
      mediaFiles.push(video);
    } else {
      const img = document.createElement('img');
      img.src = `https://media.cnn.com/api/v1/images/stellar/prod/${im[0]}.jpg?q=h_${ob.height || 700},c_fill/f_webp`;
      imCont.appendChild(img);
      imCont.classList.toggle('active', i === 0);
      mediaFiles.push(img);
    }
    scr1.appendChild(imCont);
    const imp = document.createElement('div');
    imp.classList.add('image-description');
    imp.innerHTML = im[1] ? `<p>${im[1]}</p>` : '';
    ftr.appendChild(imp);
    imp.classList.toggle('active', i === 0);

    const capt = document.createElement('div');
    capt.classList.add('image-caption');
    capt.innerHTML = im[2] || '';
    capt.classList.toggle('active', i === 0);
    ftr.appendChild(capt);
  });

  const fnSc = () => {
    const scrollPercent = (scr1.scrollLeft / (scr1.scrollWidth - scr1.clientWidth)) * 100;
    let currentIndex = Math.round((scrollPercent / 100) * (ob.images.length - 1)) + 1;
    currentIndex = (Number.isNaN(currentIndex)) ? 1 : currentIndex;

    mediaFiles.forEach((el, index) => {
      if (el.tagName.toLowerCase() === 'video') {
        if (index + 1 !== currentIndex) {
          el.pause();
        }
      }
    });

    if (scrollPercent && (currentIndex !== gal.dataset.currentIndex)) {
      gal.querySelectorAll('.active').forEach(el => el.classList.remove('active'));
      const actv1 = ftr.querySelectorAll('.image-description')[currentIndex - 1];
      actv1.classList.add('active');
      const actv2 = ftr.querySelectorAll('.image-caption')[currentIndex - 1];
      actv2.classList.add('active');
      const actv3 = gal.querySelectorAll('.scroll-container>div')[currentIndex - 1];
      actv3.classList.add('active');
      gal.dataset.currentIndex = currentIndex;
    }
    spn.textContent = currentIndex;
    gal.dataset.currentIndex = currentIndex;
    navPrev.classList.toggle('enabled', currentIndex > 1);
    navNext.classList.toggle('enabled', currentIndex < scr1.childNodes.length);
  };

  scr1.addEventListener('scroll', fnSc);
  fnSc();

  const mobileMq = window.matchMedia('(max-width: 500px)');
  function onMobileBreakpointChange() {
    syncGalleryVideoSources(gal, mobileMq.matches);
    galRez();
  }
  if (mobileMq.addEventListener) {
    mobileMq.addEventListener('change', onMobileBreakpointChange);
  } else if (mobileMq.addListener) {
    mobileMq.addListener(onMobileBreakpointChange);
  }

  galRez();
  sendHeight();
}


if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
    // console.log(zion);
  }
};


function draw(initialWidth) {
  console.log('Drawing graphic with initial width:', initialWidth);
  galRez();
  // const container = select('#graphic');
  // container.html('');

  // const fallbackWidth = container.node().clientWidth || 600;
  // const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  // const isMobile = safeWidth <= 500;

  // const heightMultiplier = isMobile ? 1 : 9 / 16;
  // const initialHeight = heightMultiplier * safeWidth;

  // const props = { initialWidth: 300, initialHeight: 3000, isMobile: false };
  // const graphicConfig = config(props);
  // graphic(graphicConfig, container, isMobile);
}

const formatHeadline = (headline) => {
  const text = headline.trim();
  if (text.endsWith("'") && !text.startsWith("'") && !text.startsWith('‘')) {
    return `‘${text.slice(0, -1)}’`;
  }
  return text;
};

const chartData = {
  container: 'gallery1',
  title: formatHeadline(meta.headline),
  images: [],
};

data.forEach((item) => {
  console.log(item);
  chartData.images.push([item.File, item.Caption, item.Credits, item.type]);
  // Do something with each item
});

// console.log(data);
scgallery(chartData);


// console.log(htmlWebpackPlugin.options.headline);
